import ApiBase from 'app/services/api/entities/Base'

function* mlmContractVersionLevels(params = {}, requestOptions = {}) {
  return yield ApiBase.privateGet('/v1/mlm_ranking/contract_version_levels/', {
    ...requestOptions,
    params
  })
}

export default {
  mlmContractVersionLevels,
}
